// extracted by mini-css-extract-plugin
export default {"container":"forget-password_container__GgijQ","paper":"forget-password_paper__grGGi","title":"forget-password_title__7WJrl","subtitle":"forget-password_subtitle__MRX41"};